import React from 'react';
import { Link } from 'react-router-dom';

import { Fade, Tooltip } from '@mui/material';

import useStyles from './styles';

interface Props {
    title: string;
    link?: string;
    accent?: boolean;
    onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
    className?: string;
}

const MenuItem: React.FC<Props> = ({ title, link, accent, children, onClick, className }) => {
    const { classes, cx } = useStyles();
    return (
        <Tooltip
            placement="bottom"
            enterDelay={0}
            leaveDelay={100}
            TransitionComponent={Fade}
            title={children ? children : null}
            classes={{ tooltip: classes.tooltip, popper: classes.popper }}
        >
            <Link className={cx(classes.root, className)} to={link ?? '#'} onClick={onClick}>
                {title}
                {accent ? <span className={classes.accent} /> : null}
            </Link>
        </Tooltip>
    );
};

export default MenuItem;
